var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcTwoWaySync = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "71px",
    viewBox: "0 0 71 71",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1.-Import",
    transform: "translate(-782.000000, -316.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(35.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2-Copy-11",
    transform: "translate(670.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-vpn",
    transform: "translate(47.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BEC4CA",
    points: "0 0 71 0 71 51.2777778 0 51.2777778"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EFF0F2",
    points: "3.94444444 3.94444444 67.0555556 3.94444444 67.0555556 45.3611111 3.94444444 45.3611111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6666667,15.7777778 L23.6663333,21.6937778 L33.5277778,21.6944444 L33.5277778,29.5833333 L23.6663333,29.5827778 L23.6666667,35.5 L11.8333333,25.6388889 L23.6666667,15.7777778 Z M49.3055556,15.7777778 L61.1388889,25.6388889 L49.3055556,35.5 L49.3053333,29.5827778 L39.4444444,29.5833333 L39.4444444,21.6944444 L49.3053333,21.6937778 L49.3055556,15.7777778 Z",
    id: "Combined-Shape",
    fill: "#2565C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5277778,51.2777778 L37.4722222,51.2777778 L37.4722222,61.1388889 L33.5277778,61.1388889 L33.5277778,51.2777778 Z M0,63.1111111 L71,63.1111111 L71,67.0555556 L0,67.0555556 L0,63.1111111 Z",
    id: "Shape",
    fill: "#BEC4CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.25,67.0555556 C53.25,69.2328889 51.4828889,71 49.3055556,71 L21.6944444,71 C19.5171111,71 17.75,69.2328889 17.75,67.0555556 L17.75,63.1111111 C17.75,60.9337778 19.5171111,59.1666667 21.6944444,59.1666667 L49.3055556,59.1666667 C51.4828889,59.1666667 53.25,60.9337778 53.25,63.1111111 L53.25,67.0555556 Z",
    id: "Path",
    fill: "#BEC4CA"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcTwoWaySync, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-two-way-sync.e3a90ae4.svg";
export { ForwardRef as ReactComponent };